/**
 * @generated SignedSource<<9f3264daa5ba30d424d7182ed1cdc709>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteValveInput = {
  valveId: string;
  clientMutationId?: string | null;
};
export type ValvesTableDeleteValveMutation$variables = {
  input: DeleteValveInput;
};
export type ValvesTableDeleteValveMutationVariables = ValvesTableDeleteValveMutation$variables;
export type ValvesTableDeleteValveMutation$data = {
  readonly deleteValve: {
    readonly valve: {
      readonly id: string;
      readonly serial: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type ValvesTableDeleteValveMutationResponse = ValvesTableDeleteValveMutation$data;
export type ValvesTableDeleteValveMutation = {
  variables: ValvesTableDeleteValveMutationVariables;
  response: ValvesTableDeleteValveMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteValvePayload",
    "kind": "LinkedField",
    "name": "deleteValve",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Valve",
        "kind": "LinkedField",
        "name": "valve",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serial",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValvesTableDeleteValveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValvesTableDeleteValveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a0257a7d31c7d7549d8b0209668b351e",
    "id": null,
    "metadata": {},
    "name": "ValvesTableDeleteValveMutation",
    "operationKind": "mutation",
    "text": "mutation ValvesTableDeleteValveMutation(\n  $input: DeleteValveInput!\n) {\n  deleteValve(input: $input) {\n    valve {\n      id\n      serial\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4aea012546dfe0c5179a8b00be0ee775";

export default node;
